import React from "react";
import PropTypes from "prop-types";
import PageTitleRenderer from "../../renderers/pageTitle";
import { PAGE_TITLE_STATUS } from "../../../../constants/actionBar";

const TitleGroup = ({ title, code, status, tooltip, navMenuAnchorEl, navDefs }) => {
  return (
    <PageTitleRenderer
      title={title}
      code={code}
      status={status}
      tooltip={tooltip}
      navDefs={navDefs}
      navMenuAnchorEl={navMenuAnchorEl}
    />
  );
};

TitleGroup.propTypes = {
  /* The title of the page. */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /* A reference value associated with the title (displayed in parentheses). */
  code: PropTypes.string,
  /* A status value associated with the title (displayed as an icon and label). */
  status: PropTypes.oneOf(Object.values(PAGE_TITLE_STATUS)),
};

TitleGroup.defaultProps = {
  title: "Page Title",
  code: "",
};

export default TitleGroup;
